export const labContentParser = (parseModifier, content) => {
  const { target, openTag, closeTag } = parseModifier
  let contentParsed = content
  const ocurrences = contentParsed.split(target).length - 1
  if (!ocurrences) return content
  const offset = ocurrences % 2 !== 0 ? 1 : 0
  for (let i = 0; i < ocurrences - offset; i++) {
    const tag = i % 2 === 0 ? openTag : closeTag
    contentParsed = contentParsed.replace(target, tag)
  }
  return contentParsed
}
